import FileModel from './globals/FileModel';

export default class DemandModelPdfModel extends FileModel {
  static get path() {
    return '/backend/stands/{id}/demand_model_pdf/{locale}';
  }
}
